module.exports = __webpack_public_path__ + "img/bj.e256535d.jpg";